
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const Terms = () => {
  return <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <Link to="/">
            <Button variant="ghost" className="mb-6">← Back to Home</Button>
          </Link>
          
          <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
          
          <div className="space-y-6 text-film-600">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">1. Acceptance of Terms</h2>
              <p>By accessing and using Safelight, you agree to be bound by these Terms of Service and all applicable laws and regulations.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">2. User Content</h2>
              <p>When posting reviews and content, you agree to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide accurate and truthful information about your airport experiences</li>
                <li>Not post content that is harmful, offensive, or violates others' rights</li>
                <li>Take responsibility for the content you share</li>
                <li>Grant Safelight a license to display and distribute your content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">3. Account Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Maintain the security of your account credentials</li>
                <li>Provide accurate profile information</li>
                <li>Not transfer your account to others</li>
                <li>Notify us of any unauthorized account use</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">4. Review Guidelines</h2>
              <p>When submitting reviews, ensure they:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Are based on personal experience</li>
                <li>Focus on film photography aspects of airports</li>
                <li>Do not contain confidential or sensitive security information</li>
                <li>Respect airport and aviation regulations</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">5. Intellectual Property</h2>
              <p>The Safelight platform, including its design, logos, and content (excluding user-generated content), is protected by copyright and other intellectual property rights.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">6. Termination</h2>
              <p>We reserve the right to terminate or suspend accounts that violate these terms or engage in inappropriate behavior on the platform.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">7. Disclaimers</h2>
              <p>Safelight is provided "as is" without warranties. We are not responsible for the accuracy of user-generated content or any consequences from using the information on our platform.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">8. Changes to Terms</h2>
              <p>We may update these terms from time to time. Continued use of the platform after changes constitutes acceptance of the new terms.</p>
              <p className="mt-2 text-sm">Last updated: February 2025</p>
            </section>
          </div>
        </div>
      </main>
    </div>;
};

export default Terms;
